import WidgetCard from '@quicktools/shared-components/components/common/Widgets/WidgetCard';

import Upload from '../Upload';
import Download from '../Download';
import { ProcessStep } from '../../types';
import { AppContext, AppProvider } from '../../store';

function Main() {
  return (
    <AppProvider>
      <AppContext.Consumer>
        {({ state }) => {
          return (
            <WidgetCard>
              {state.processStep === ProcessStep.Upload && <Upload />}
              {state.processStep === ProcessStep.Download && <Download />}
            </WidgetCard>
          );
        }}
      </AppContext.Consumer>
    </AppProvider>
  );
}

export default Main;
